import { render, staticRenderFns } from "./userCouponList.vue?vue&type=template&id=5f0e0d99&scoped=true"
import script from "./userCouponList.vue?vue&type=script&lang=ts"
export * from "./userCouponList.vue?vue&type=script&lang=ts"
import style0 from "./userCouponList.vue?vue&type=style&index=0&id=5f0e0d99&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0e0d99",
  null
  
)

export default component.exports